import { useState, useEffect } from "react";
import dayjs from "dayjs";

// Only converts dayjs for keys named "startDate" or "endDate"
const replacer = (key, value) => {
  if (key === "startDate" || key === "endDate") {
    return {
      __isDayjs: true,
      iso: value,
    };
  }
  return value;
};

// Only revives keys named "startDate" or "endDate" that have the { __isDayjs: true, iso: ... } shape
const reviver = (key, value) => {
  if ((key === "startDate" || key === "endDate") && value?.__isDayjs === true) {
    return dayjs(value.iso);
  }
  return value;
};

export const useSessionState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    if (typeof window === "undefined") return defaultValue;

    try {
      const storedValue = sessionStorage.getItem(key);
      if (storedValue === null) return defaultValue;
      return JSON.parse(storedValue, reviver);
    } catch (error) {
      return defaultValue;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      const serialized = JSON.stringify(state, replacer);
      sessionStorage.setItem(key, serialized);
    } catch (error) {
      console.error("Error saving to session storage:", error);
    }
  }, [key, state]);

  return [state, setState];
};
